module.exports = __webpack_public_path__ + "static/media/Qi_Dang_Resume.24da6625.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Qi_Dang_Resume.pdf
// module id = 22
// module chunks = 0